import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/activity/nft-img-icon.png';
const _withScopeId = n => (_pushScopeId("data-v-26946c31"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "seq-box"
};
const _hoisted_2 = {
  class: "img-title"
};
const _hoisted_3 = {
  class: "seq-title render-line-clamp"
};
const _hoisted_4 = {
  class: "seq-list-box"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "seq-shadow"
}, null, -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "seq-tips"
}, "选择参与合成的藏品，可多选", -1));
const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认 ");
const _hoisted_10 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    class: "seq",
    show: $options.show,
    "onUpdate:show": _cache[2] || (_cache[2] = $event => $options.show = $event),
    onOpen: $options.open
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("i", {
      class: "seq-close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePicker && $options.closePicker(...args))
    }), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      class: "img-info",
      style: _normalizeStyle(`background-image: url(${_ctx.$imgUrlFilter($props.seq_url, 200)})`)
    }, null, 4)]), _createElementVNode("div", _hoisted_3, _toDisplayString($props.seq_tit), 1)]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      class: _normalizeClass(['seq-list', `seq-list-${$props.seq_list.length % 3}`])
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.seq_list, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(['seq-item', {
          'is-check': $data.tempObj[item.stock_hash]
        }]),
        onClick: $event => $options.checkSeq(item)
      }, [_hoisted_6, _createElementVNode("span", null, _toDisplayString(item.seq), 1)], 10, _hoisted_5);
    }), 128))], 2), _hoisted_7]), _hoisted_8, _createElementVNode("div", {
      class: "seq-add-btn",
      onClick: _cache[1] || (_cache[1] = (...args) => $options.getCheckSeq && $options.getCheckSeq(...args))
    }, [_hoisted_9, $data.seq_check_list.length ? (_openBlock(), _createElementBlock("span", _hoisted_10, "选择(" + _toDisplayString($data.seq_check_list.length) + "个)", 1)) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["show", "onOpen"]);
}